import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

interface ISanitizedUrlHash {
  [originalUrl: string]: string;
}

@Pipe({ name: 'sanitizeUrl', pure: true })
export class SanitizeUrlPipe implements PipeTransform {
  private sanitizedUrlHash: ISanitizedUrlHash = {};
  private defaultImageSmall = '/assets/images/folder.png';

  constructor(private _sanitizer: DomSanitizer) {}

  transform(value: string, args?: any): string {
    if (!value) {
      return this.defaultImageSmall;
    }
    // IMPROTANT!: check the hash if we have the sanitized url and if so get that already created object.
    // because this is a function binded to the src prop of img element it will causes each tick call to creates a new sanitized object
    // and that will result a call on the network to get the image again. (resulted real slowness in FF)
    // this hash insures that the same object is returned each time so angular does not detect this as a change and no redundant network calls
    // are issued.
    if (this.sanitizedUrlHash[value]) {
      return this.sanitizedUrlHash[value];
    } else {
      const result = this._sanitizer.sanitize(SecurityContext.URL, this._sanitizer.bypassSecurityTrustResourceUrl(value));
      this.sanitizedUrlHash[value] = result;
      return this.sanitizedUrlHash[value];
    }
  }
}
